import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledClearIconContainer = styled.div`
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);

    &::after {
        content: "";
        height: 200%;
        left: -50%;
        position: absolute;
        top: -50%;
        width: 200%;
    }
`;

export const StyledInput = styled.input``;

export const StyledSearchInputContainer = styled.div<{ isDisabled: boolean; isFocused: boolean }>`
    align-items: center;
    display: flex;
    overflow: hidden;
    position: relative;
    background-color: ${({ isDisabled }) => (isDisabled ? colorsPalettes.bluegrey["200"] : colorsPalettes.carbon["0"])};

    ${StyledInput} {
        ${mixins.setFont({ $size: 14, $color: colorsPalettes.carbon["400"], $weight: 400 })};
        border: none;
        box-shadow: none;
        cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "unset")};
        display: block;
        height: 40px;
        line-height: 16px;
        margin: 0;
        padding: 0 0 0 8px;
        width: 100%;
        background-color: ${({ isDisabled }) =>
            isDisabled ? colorsPalettes.bluegrey["200"] : colorsPalettes.carbon["0"]};

        &::placeholder {
            color: ${colorsPalettes.carbon["200"]};
        }
    }
`;

export const StyledBoxWrapper = styled.div`
    flex-grow: 1;
`;
